import Column from '@components/Column';
import Row from '@components/Row';
import Skeleton from '@components/Skeleton';
import styled from '@emotion/styled';

interface Props {
    count?: number;
}

function GiftBoxItemSkeletons({ count = 5 }: Props) {
    return (
        <Column fullWidth aria-busy>
            {Array.from({ length: count }).map((_, idx) => (
                <Item key={`gift-box-sk-${idx}`} fullWidth align='center' spacing={4}>
                    <Skeleton shape='block' width={100} height={67} />
                    <Column fullWidth spacing={1}>
                        <Skeleton width='40%' height={20} />
                        <Skeleton width='70%' height={20} />
                        <Skeleton width='50%' height={20} />
                    </Column>
                </Item>
            ))}
        </Column>
    );
}

const Item = styled(Row)`
    padding: 16px 0;
`;

export default GiftBoxItemSkeletons;
